import * as React from 'react';
import { css } from 'aphrodite';

import styles from './onboardingFormIconStyles';

export default class ContactSVG extends React.PureComponent {
  render() {
    return (
      <svg
        className={css(styles.positioning)}
        width="20px"
        height="20px"
        viewBox="0 0 20 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        focusable="false"
      >
        <title>icon_contact</title>
        <defs />
        <g id="icon_contact" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round">
          <g id="user" transform="translate(2.500000, 3.000000)" stroke="#757575" strokeWidth="1.6">
            <ellipse id="Oval" strokeLinejoin="round" cx="7.5" cy="3.11111111" rx="3.25" ry="3.11111111" />
            <path
              d="M0.499998547,14 C0.5,12.0439453 0.473693848,9 7.5,9 C14.5263062,9 14.5,11.9846191 14.5000007,14"
              id="Path-2"
            />
          </g>
        </g>
      </svg>
    );
  }
}
